import { FormFieldEnums } from "shared/types/enums";
import { FormFieldType } from "shared/types";
import { JSX } from "react";
import TextLabel from "../forms/labels/TextLabel";
import TextAreaInput from "../forms/inputs/TextAreaInput";
import {
  CheckboxInput,
  DateInput,
  SelectInput,
  SwitchInput,
  ToggleInput,
  TextInput,
} from "../forms/inputs";
import ButtonInput from "../forms/buttons/ButtonInput";
import ToolTipButton from "../forms/buttons/ToolTipButton";

// Lazy-loaded components
// const ButtonInput = lazy(
//   () => import("shared/components/forms/buttons/ButtonInput")
// );
// const DateInput = lazy(
//   () => import("shared/components/forms/inputs/DateInput")
// );
// const TextInput = lazy(
//   () => import("shared/components/forms/inputs/TextInput")
// );
// const SwitchInput = lazy(
//   () => import("shared/components/forms/inputs/SwitchInput")
// );
// const ToggleInput = lazy(
//   () => import("shared/components/forms/inputs/ToggleInput")
// );
// const SelectInput = lazy(
//   () => import("shared/components/forms/inputs/SelectInput")
// );
// const CheckboxInput = lazy(
//   () => import("shared/components/forms/inputs/CheckBoxInput")
// );
// const TextAreaInput = lazy(
//   () => import("shared/components/forms/inputs/TextAreaInput")
// );
// const TextLabel = lazy(
//   () => import("shared/components/forms/labels/TextLabel")
// );
// const ToolTipButton = lazy(
//   () => import("shared/components/forms/buttons/ToolTipButton")
// );

export const GenerateForm = (json: FormFieldType[]): JSX.Element[] => {
  if (json.length === 0) return [];

  return json.map((field, index) => {
    if (field.type === FormFieldEnums.Group) {
      return (
        <div key={field.id} className={field.className}>
          {GenerateForm(field.fields)}
        </div>
      );
    }

    switch (field.type) {
      case FormFieldEnums.Label:
        return (
          <TextLabel
            key={field.id}
            type={field.type}
            id={field.id}
            className={field.className}
            label={field.label}
          />
        );
      case FormFieldEnums.Email:
      case FormFieldEnums.Number:
      case FormFieldEnums.Text:
        return (
          <TextInput
            id={field.id}
            key={field.id}
            className={field.className}
            type={field.type}
            placeholder={field.placeholder}
            required={field.required}
            value={field.value}
          />
        );
      case FormFieldEnums.Textarea:
        return (
          <TextAreaInput
            key={field.id}
            id={field.id}
            className={field.className}
            type={field.type}
            placeholder={field.placeholder}
            required={field.required}
            value={field.value}
          />
        );
      case FormFieldEnums.Date:
        return (
          <DateInput
            key={field.id}
            id={field.id}
            placeholder={field.placeholder}
            className={field.className}
            type={field.type}
            required={field.required}
          />
        );
      case FormFieldEnums.Button:
        return (
          <ButtonInput
            key={field.id}
            id={field.id}
            className={field.className}
            type={field.type}
            label={field.label}
          />
        );
      case FormFieldEnums.Checkbox:
        return (
          <CheckboxInput
            key={field.id}
            id={field.id}
            className={field.className}
            type={field.type}
            required={field.required}
            label={field.label}
            value={field.value}
          />
        );
      case FormFieldEnums.Switch:
        return <SwitchInput key={field.id} />;
      case FormFieldEnums.ToolTipButton:
        return (
          <ToolTipButton
            key={field.id}
            id={field.id}
            className={field.className}
            type={field.type}
            value={field.value}
            title={field.title}
          />
        );
      case FormFieldEnums.CountriesSelect:
        return (
          <SelectInput
            key={field.id}
            type={field.type}
            id={field.id}
            required={field.required}
            placeholder={field.placeholder}
            value={field.value}
          />
        );
      case FormFieldEnums.ToggleMulti:
      case FormFieldEnums.Toggle:
        return (
          <ToggleInput
            key={field.id}
            className={field.className}
            required={field.required}
            type={field.type}
            id={field.id}
            options={field.options}
          />
        );

      default:
        return <div key={index}>Uknown Element</div>;
    }

    // return <SuspenseLayout key={field.id}>{renderField()}</SuspenseLayout>;
  });
};
